// extracted by mini-css-extract-plugin
export default {"unit":"8px","smBreak":"600px","mapViewContainer":"U0PV7YYIVyQbuoUtTJxL","hotelList":"wyo7EZkoBeIzcdck_D98","loading":"YYClfomI5WzKRucidbAB","infiniteScroll":"O6CGyZ5kQ8mhES6JIjjI"};